module.exports = __webpack_public_path__ + "static/img/02.c393fbbe.png";